export enum SHARE_SOCIAL_NETWORKS {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=257206106
     */
    TWITTER_MENTION_LIMITATION = 'SHARE.TWITTER_MENTION_LIMITATION',
}
